module.exports = __webpack_public_path__ + "static/media/contact-image3.85501305.jpg";